import _ from 'lodash';

import { CartItem } from '@/features/cart/types';

export const groupCartItemsBySeller = (cartItems: CartItem[]) => {
  return _.groupBy(cartItems, (item) => item.product.store.slug);
};

export const calculateTotalPrice = (items: CartItem[]) => {
  const priceSubtotal = items.reduce(
    (acc, item) => acc + parseFloat(item.price ?? item.product.price),
    0,
  );

  const shippingSubtotal = Math.max(
    ...items.map((item) => parseFloat(item.product.shippingCost)),
  );

  const priceTotal = priceSubtotal + shippingSubtotal;

  return {
    priceSubtotal,
    shippingSubtotal,
    priceTotal,
  };
};
